<div class="spinner-wrapper margSpinner">
	<ion-spinner></ion-spinner>
	<ion-text>{{ message }}</ion-text>
</div>